import React from 'react';
export const Solution = () => {
  return <section className="py-6 sm:py-8" data-id="element-212">
      <h2 className="text-2xl font-bold text-[#E55A88] mb-5" data-id="element-213">
        The Hidden Connection
      </h2>
      <div className="prose max-w-none text-base" data-id="element-214">
        <p data-id="element-215">
          Inside your gut lives something called the "estrobolome"—bacteria that
          help process your hormones.
        </p>
        <p data-id="element-216">When menopause hits, these beneficial bacteria die off, causing:</p>
        <ul className="pl-5 space-y-2 my-4" data-id="element-217">
          <li className="flex items-start" data-id="element-218">
            <span className="text-[#E55A88] mr-2" data-id="element-219">•</span>
            <span data-id="element-220">Temperature regulation problems (hot flashes)</span>
          </li>
          <li className="flex items-start" data-id="element-221">
            <span className="text-[#E55A88] mr-2" data-id="element-222">•</span>
            <span data-id="element-223">Metabolic disruption (weight gain)</span>
          </li>
          <li className="flex items-start" data-id="element-224">
            <span className="text-[#E55A88] mr-2" data-id="element-225">•</span>
            <span data-id="element-226">Mood chemical imbalances (anxiety/depression)</span>
          </li>
          <li className="flex items-start" data-id="element-227">
            <span className="text-[#E55A88] mr-2" data-id="element-228">•</span>
            <span data-id="element-229">Sleep cycle chaos (insomnia)</span>
          </li>
          <li className="flex items-start" data-id="element-230">
            <span className="text-[#E55A88] mr-2" data-id="element-231">•</span>
            <span data-id="element-232">Cognitive issues (brain fog)</span>
          </li>
        </ul>
        <p data-id="element-233">
          <strong data-id="element-234">
            Here's the kicker: 95% of your "happiness chemical" serotonin is
            made in your GUT, not your brain.
          </strong>
        </p>
        <p data-id="element-235">
          This is why treating each symptom separately never works. You need to
          fix the root cause.
        </p>
      </div>
      <div className="my-8" data-id="element-236">
        <h2 className="text-2xl font-bold text-[#E55A88] mb-5" data-id="element-237">
          The Breakthrough Solution
        </h2>
        <div className="flex flex-col md:flex-row gap-6" data-id="element-238">
          <div className="md:w-1/2" data-id="element-239">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/774yb7sty41JrtZC7dAR89/0b42b807-d313-4843-815f-83526a34e2b8_%281%29.png" alt="Dr. Sarah Chen smiling at herself in the mirror" className="w-full h-auto rounded-md" data-id="element-240" />
          </div>
          <div className="md:w-1/2 prose max-w-none text-base" data-id="element-241">
            <p data-id="element-242">
              Dr. Sarah Chen, a gastroenterologist suffering through her own
              menopause nightmare, discovered a groundbreaking 2025 study on
              probiotics and menopause.
            </p>
            <p data-id="element-243">The results were incredible:</p>
            <ul className="pl-5 space-y-2 my-4" data-id="element-244">
              <li className="flex items-start" data-id="element-245">
                <span className="text-[#E55A88] mr-2" data-id="element-246">✓</span>
                <span data-id="element-247">73% reduction in hot flashes</span>
              </li>
              <li className="flex items-start" data-id="element-248">
                <span className="text-[#E55A88] mr-2" data-id="element-249">✓</span>
                <span data-id="element-250">Significant mood improvements</span>
              </li>
              <li className="flex items-start" data-id="element-251">
                <span className="text-[#E55A88] mr-2" data-id="element-252">✓</span>
                <span data-id="element-253">Better sleep within 4-6 weeks</span>
              </li>
              <li className="flex items-start" data-id="element-254">
                <span className="text-[#E55A88] mr-2" data-id="element-255">✓</span>
                <span data-id="element-256">Reduced belly weight gain</span>
              </li>
              <li className="flex items-start" data-id="element-257">
                <span className="text-[#E55A88] mr-2" data-id="element-258">✓</span>
                <span data-id="element-259">Clearer thinking and focus</span>
              </li>
            </ul>
            <p data-id="element-260">
              But the specific probiotic strains weren't available anywhere...
            </p>
            <h3 className="text-2xl font-bold text-[#E55A88] my-4" data-id="element-261">
              So she created MenoBloom.
            </h3>
          </div>
        </div>
        <div className="flex justify-center my-8" data-id="element-262">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cnZwwqE8K3jvmY5BxMjbuc/40_Billion_CFU_Probiotics_Supports_gut_health_2B_immune_function_%288%29.png" alt="MenoBloom Menopause Support Probiotic Capsules" className="w-full max-w-md h-auto" data-id="element-263" />
        </div>
      </div>
    </section>;
};